/**
 * @template [T=unknown]
 * @typedef {import('./Event.js').default<T>} Event
 */
/**
 * @template [T=unknown]
 * @typedef {import('./MessageBus.js').MessageHandler<T>} MessageHandler
 */

export { default as MessageBus } from './MessageBus.js';
